import React from 'react'
import createReactClass from 'create-react-class'
import PropTypes from 'prop-types'

// React 15-era components still call React.createClass.
// Keep them running during phased migration to modern components.
if (!React.createClass) {
  React.createClass = createReactClass
}

// react-bootstrap@0.30.x and react-overlays@0.x access React.PropTypes,
// which was removed in React 15.5. Polyfill it from the prop-types package.
if (!React.PropTypes) {
  React.PropTypes = PropTypes
}
